import React from 'react';

const SvgComponent = props => (
  <svg
    width={91}
    height={128}
    viewBox="0 0 91 128"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path
        d="M80.6232 93.7052L63.3816 88.1602H27.5988L10.3572 93.7052C4.72557 95.7846 1 101.156 1 107.221V126.975H89.9804V107.221C89.9804 101.156 86.2548 95.7846 80.6232 93.7052Z"
        fill="#fff"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M56.9699 76.0312H34.01V90.2404H56.9699V76.0312Z"
        fill="#fff"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M71.0933 59.3093H66.9346V47.4395H71.2666C73.6926 47.4395 75.6853 49.4322 75.6853 51.8582V54.7173C75.6853 57.2299 73.6926 59.3093 71.0933 59.3093Z"
        fill="#fff"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.8883 59.3093H24.0471V47.4395H19.715C17.2891 47.4395 15.2963 49.4322 15.2963 51.8582V54.7173C15.2097 57.2299 17.2891 59.3093 19.8883 59.3093Z"
        fill="#fff"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.5343 82.6167C33.6645 82.6167 23.9607 72.9129 23.9607 61.0431V43.1084C23.9607 38.6897 27.5996 35.0508 32.0183 35.0508H58.8771C63.2957 35.0508 66.9347 38.6897 66.9347 43.1084V61.303C66.9347 72.9996 57.3175 82.6167 45.5343 82.6167Z"
        fill="#fff"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M80.363 23.0068C80.363 15.2091 74.0382 8.97098 66.3272 8.97098C63.6413 8.97098 61.1287 9.75075 58.9627 11.0504C57.2298 5.24541 51.8581 1 45.4467 1C39.0352 1 33.7501 5.24541 32.0173 10.9637C29.8513 9.66411 27.3387 8.88434 24.6528 8.88434C16.8551 8.88434 10.6169 15.2091 10.6169 22.9202C10.6169 30.458 16.5952 36.6095 24.0463 36.9561V46.14H66.9336V37.0427C74.3848 36.6961 80.363 30.5446 80.363 23.0068Z"
        fill="#fff"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M76.7618 24.738C76.7618 17.8826 71.5272 12.3983 65.1454 12.3983C62.9225 12.3983 60.843 13.0839 59.0504 14.2264C57.6162 9.12298 53.1705 5.39062 47.8642 5.39062C42.5579 5.39062 38.1839 9.12298 36.7497 14.1502C34.9571 13.0077 32.8776 12.3221 30.6547 12.3221C24.2012 12.3221 19.0383 17.8826 19.0383 24.6618C19.0383 31.2886 23.9861 36.6967 30.1528 37.0014V45.0755H65.6473V37.0776C71.8141 36.7729 76.7618 31.3648 76.7618 24.738Z"
        fill="#fff"
      />
      <path
        d="M59.5702 94.5718L45.4477 98.0374L31.3252 94.5718C28.466 93.5321 26.9065 92.579 26.9065 90.1531C26.9065 87.7271 28.8992 85.7344 31.3252 85.7344L45.4477 89.2L59.5702 85.7344C61.9961 85.7344 63.9889 87.7271 63.9889 90.1531C63.9889 92.6657 62.0828 93.792 59.5702 94.5718Z"
        fill="#fff"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.502 105.662C38.6032 109.561 32.0185 109.127 32.0185 109.127C32.0185 109.127 31.6719 102.456 35.4841 98.6438C39.2963 94.8316 45.9677 95.1781 45.9677 95.1781C45.9677 95.1781 46.3142 101.849 42.502 105.662Z"
        fill="#fff"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M49.5195 105.662C53.4184 109.561 60.0031 109.127 60.0031 109.127C60.0031 109.127 60.3496 102.456 56.5374 98.6438C52.7252 94.8316 46.0539 95.1781 46.0539 95.1781C46.0539 95.1781 45.6207 101.849 49.5195 105.662Z"
        fill="#fff"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.9673 98.0371C48.0248 98.0371 49.6928 96.3691 49.6928 94.3115C49.6928 92.2539 48.0248 90.5859 45.9673 90.5859C43.9097 90.5859 42.2417 92.2539 42.2417 94.3115C42.2417 96.3691 43.9097 98.0371 45.9673 98.0371Z"
        fill="#fff"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.0996 65.3748C45.0996 65.3748 41.1141 63.2087 38.1683 64.4217C35.2225 65.5481 33.9228 68.4072 30.9771 68.0606C30.9771 67.974 42.2404 75.2519 45.0996 65.3748Z"
        fill="#fff"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.8792 65.3748C45.8792 65.3748 49.8646 63.2087 52.8104 64.4217C55.7562 65.5481 57.0558 68.4072 60.0016 68.0606C60.0016 67.974 48.7383 75.2519 45.8792 65.3748Z"
        fill="#fff"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default SvgComponent;
